import { yupResolver } from "@hookform/resolvers/yup";
import Form from "components/forms/form";
import { buildDefaultValues, buildUserValidationSchema } from "lib/entity";
import { ListEntityField } from "models/list-entity-field";
import { EntityCollectionValue } from "models/list-user-entity-collection-value";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import FieldGrid from "components/grid/field-grid";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { FormSubmitFunction } from "lib/form";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import { List } from "models/list";
import { ListEntity } from "models/list-entity";

interface ListEntityFieldSingleFormProps {
  list: List;
  listEntity: ListEntity;
  listEntityFields: ListEntityField[];
  entityCollectionValues: EntityCollectionValue[];

  // this should have the direction as well?
  onSubmit: FormSubmitFunction;
  onPrevious: () => Promise<void>;
}

const ListEntityFieldSingleForm: FunctionComponent<
  ListEntityFieldSingleFormProps
> = ({
  list,
  listEntity,
  listEntityFields,
  entityCollectionValues,
  onSubmit,
  onPrevious,
}) => {
  // build validation schema based on fields
  const schema = buildUserValidationSchema(listEntityFields);

  // do default values
  const defaultValues = buildDefaultValues(
    listEntityFields,
    entityCollectionValues,
  );

  // form magic
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  const buttons: FormButtonInterface[] = [];

  if (listEntity.order > 0 || list.obligation) {
    buttons.push({
      ...CancelButton,
      text: "Edelliseen",
      onClick: onPrevious,
      align: "left",
    });
  }
  buttons.push({
    ...SubmitButton,
    text: "Tallenna ja jatka",
    align: "right",
  });

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <FieldGrid listEntityFields={listEntityFields} />
      <FormButtons buttons={buttons} />
    </Form>
  );
};

export default ListEntityFieldSingleForm;
